__webpack_require__.p = "https://gamma.eu.safer.whs.amazon.dev/";